var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"ls-com-breadcrumb",attrs:{"separator":"> "}},_vm._l((_vm.breadcrumbList),function(item,i){return _c('el-breadcrumb-item',{key:i,class:[item.curCss],attrs:{"to":{ name: item.routeName ? item.routeName : '' }}},[_vm._v(_vm._s(item.menuName))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }